import { render, staticRenderFns } from "./Associati.vue?vue&type=template&id=6d655267"
import script from "./Associati.vue?vue&type=script&lang=js"
export * from "./Associati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports